import React from "react";
import "./ECLCheckBox.css";

/**
 * ECLCheckbox
 *
 * @param {object} props
 *    -ID - {string} - required - Used as ID for the input
 *    -name - {string} - optional - Used for labeling the checkbox
 *    -defaultChecked - {bool} - optional - used to set initial state of checkbox
 *    -onClick - {function} - optional - sets the onClick event for the checkbox container,
 *          it is provided the event from the input itself
 *          (i.e. the assigned function should be onclick={ (e) => {do stuff here with the e object} } )
 * @return {*}
 */
const ECLCheckBox = (props) => {
   //PROPS:
   //id - string - will be used as the ID for the input
   //name - jsx - if this is passed, there will be a label for the checkbox
   //onClick - function-  fires when checkbox is clicked, passes up event
   //defaultChecked - bool - initial

   return (
      <div className="checkbox-option">
         <div className={`ecl-checkbox`}>
            <input
               id={props.id}
               type="checkbox"
               defaultChecked={props.defaultChecked}
               onClick={(e) => {
                  props.onClick && props.onClick(e);
               }}
            ></input>
         </div>
         {props.name !== undefined ? (
            <label htmlFor={props.id} title={props.name}>
               {props.name}
            </label>
         ) : null}
      </div>
   );
};
export default ECLCheckBox;
